import React, { useState } from "react";
import styled from "styled-components";
import { SignIn } from "components";
import { Sidebar, ScreenSizes, Logo } from "components/shared";
import { Route } from "react-router-dom";
import { connect } from "react-redux";
import { Icon } from "semantic-ui-react";

const Shell = styled.div`
  display: flex;
  min-height: 100%;
  background-color: ${(props) => props.theme.backgroundcolor};
`;

const Main = styled.div`
  flex: 1;
  min-width: 0;
`;

const MainInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 2rem;

  ${ScreenSizes.lessThan("mobile")`
  padding: 1rem;
  `}
`;

const MobileTopBar = styled.div`
  display: none;

  ${ScreenSizes.lessThan("mobile")`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background-color: ${(props) => props.theme.headerBackgroundColor};
  border-bottom: 1px solid ${(props) => props.theme.shadowColor};
  `}
`;

const HamburgerButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${(props) => props.theme.textDark};
`;

const PrivateRoute = ({ component: Component, authenticated, ...rest }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated ? (
          <Shell>
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <Main>
              <MobileTopBar>
                <HamburgerButton onClick={() => setSidebarOpen(true)} aria-label="Open menu">
                  <Icon name="align left" size="large" />
                </HamburgerButton>
                <Logo />
              </MobileTopBar>
              <MainInner>
                <Component {...props} />
              </MainInner>
            </Main>
          </Shell>
        ) : (
          <SignIn {...props} />
        )
      }
    />
  );
};

const mapStateToProps = (state) => ({
  authenticated: state.session.authenticated,
});

export default connect(mapStateToProps)(PrivateRoute);
